import { useHistory } from 'react-router-dom'

export const useNavigation = () => {
	const history = useHistory()

	const handleNavigation = path => {
		history.push(path)
	}

	return handleNavigation
}
